import React, { memo, useEffect } from "react";
import { message, Icon, Spin, Button, Modal, Form, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Type from "@actionTypes";
import { checkPwd } from "../../utils/utils";
import "./index.less";

const PasswordForm = (props) => {
  const [form] = Form.useForm();
  useEffect(() => {
    form.setFieldsValue({username: props.username})
    return () => {
      
    }
  }, [props.username])
  const onFinish = async () => {
    await form.validateFields();
    const params = form.getFieldsValue();
    const { oldpwd, newpwd, conpwd } = params;
    if (oldpwd === "" || newpwd === "" || conpwd === "") {
      message.warning("请填写完整");
      return;
    }
    if (newpwd !== conpwd) {
      message.warning("确认新密码需要与新密码相同");
      return;
    }
    if (newpwd === oldpwd) {
      message.warning("新旧密码不能一致");
      return;
    }
    if (newpwd.length < 6 || newpwd.length > 20) {
      message.warning("密码长度必须在6-20位");
      return;
    }
    if (checkPwd(newpwd)) {
      props.changePwd({
        newPassword: newpwd,
        oldPassword: oldpwd,
      });
    } else {
      message.warning(
        "密码必须包含大写字母、小写字母、数字、特殊字符中的3种或以上"
      );
      return;
    }
  };

  return (
    <div className="edit-form">
      <Form form={form} size="large" onFinish={onFinish}>
        <div className="form-item">
          <label>账号:</label>
          <Form.Item
            name="username"
            required={false}
            rules={[{ required: true, message: "请输入账号!" }]}
          >
            <Input placeholder="请输入账号" className="input" disabled/>
          </Form.Item>
        </div>
        <div className="form-item">
          <label>旧密码:</label>
          <Form.Item
            name="oldpwd"
            required={false}
            rules={[{ required: true, message: "请输入旧密码!" }]}
          >
            <Input.Password
              placeholder="请输入旧密码"
              className="input"
              visibilityToggle={false}
            />
          </Form.Item>
        </div>
        <div className="form-item">
          <label>新密码:</label>
          <Form.Item
            name="newpwd"
            required={false}
            rules={[{ required: true, message: "请输入新密码!" }]}
          >
            <Input.Password
              placeholder="请输入新密码"
              className="input"
              visibilityToggle={false}
            />
          </Form.Item>
        </div>
        <div className="form-item">
          <label>确认新密码:</label>
          <Form.Item
            name="conpwd"
            required={false}
            rules={[{ required: true, message: "请再次输入新密码!" }]}
          >
            <Input.Password
              placeholder="请再次输入新密码"
              className="input"
              visibilityToggle={false}
            />
          </Form.Item>
        </div>

        <div className="rule">
          新密码长度必须为6-20位，且必须包含大写字母、小写字母、数字、特殊字符中的3种或以上。
        </div>

        <Form.Item>
          <Button type="primary" size="large" htmlType="submit">
            提交
          </Button>
          <Button
            type="default"
            onClick={() => {
              window.history.go(-1);
            }}
          >
            返回
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

const EditPassword = () => {

  const dispatch = useDispatch();
  const { username }= useSelector((state) => state.app);
  const changePwd = (params) => {
    dispatch({
      type: Type.CHANGE_PWD,
      params,
    });
  };

  return (
    <div className="edit-password">
      <div className="middle-bg"></div>
      <div className="content">
        <div className="title">数字调解平台——修改密码</div>
        <PasswordForm  changePwd={changePwd} username={username}/>
      </div>
    </div>
  );
};

export default memo(EditPassword);
